import React, { useLayoutEffect, useEffect, useState } from "react";
import { useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import { useMedia } from "use-media";
import commonUtil from '../../../common/commonUtil';
import { Label } from "../../../components/atoms/label";
import logo from "../../../resources/icons/logo_reservations.svg";
import "../../../resources_membership_hotel/css/common/header.css";
import { Link } from "../../atoms/link";

export const HeaderContainer = (props) => {
  const { state, onClickOpenReservationPopupWindow, onClickOpenSenyuubiWindow, setPathSetLoading, importedFlg = false } = props;
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const history = useHistory();
  const store = useStore();
  const login = store.getState().login;
  const loginType = login.loginType
  // HACK 小手先対応
  const LINEFEED_LABEL = "お客様情報入力（人数・レストラン変更）";
  const prevScreenInfo = store.getState().prevScreenInfo;
  const resvKaiinken = store.getState().resvKaiinken;
  const [targetKeiyakuNo, setTargetKeiyakuNo] = useState("");
  const searchParam = store.getState().membershipSearchParam;
  const pointKaiinId = resvKaiinken?.[0]?.memberCd ? resvKaiinken[0].memberCd : "";

  useLayoutEffect(() => {
    store.dispatch({ type:"PREV_SCREEN_INFO", payload: { prevScreenInfo: {currentPath: history.location.pathname , prevPath: prevScreenInfo.currentPath}} });
    if(setPathSetLoading){
      setPathSetLoading(false);
    }
  },[])

  useEffect(() => {
    let startDate = store.getState().membershipResvStartDate;
    if (startDate && startDate != commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd")) {
      store.dispatch({ type: "OVERNIGHT_FLG", payload: { overnightFlg: true } })
      if (!loginType || loginType === 'MEMBER') {
        history.push("/reserve/hotel/search");
      } else if (loginType === 'CRAWL') {
        history.push("/reserve/hotel/crawlSearch");
      }
    }
  }, []);

  useEffect(() => {
    if (searchParam?.keiyakuNo) {
      setTargetKeiyakuNo(searchParam.keiyakuNo);
    } else {
      const reserveInfo = store.getState().membershipReserveComf;
      if (reserveInfo?.keiyakuNo) {
        setTargetKeiyakuNo(reserveInfo.keiyakuNo);
      }
    }
  }, [searchParam]);

  const onClickBack = () => {
    history.push(props.path, { locationInfo: history.location });
  }
  const onClickIcon = () => {
      if (loginType === 'MEMBER') {
          history.push("/reserve/top");
      } else if (loginType === 'CRAWL') {
          history.push("/reserve/hotel/crawlSearch");
      }
  };
  const onClickSenyuubi = () => {
    const currentPage = history.location.pathname;
    if (currentPage.indexOf("hotel/search") != -1) {
      if (resvKaiinken?.length) {
        // 会員権
        let keiyakuNo = "";
  
        resvKaiinken.forEach((data) => {
          if (data.selected === true) {
            keiyakuNo = data.keiyakuNo;
          }
        });
        onClickOpenSenyuubiWindow(keiyakuNo)
      }
    } else {
      if (targetKeiyakuNo) {
        onClickOpenSenyuubiWindow(targetKeiyakuNo)
      }
    }
  }
  return (
    <header>
      {!props.hideLogo && <div className="membership_headerBaseWrapper">
        <img onClick={onClickIcon} src={logo} className="membership_headerBaseLeftImg" />
        <div className="headerIcons">
          <div className={props.bookedConfirmLabel && !importedFlg ? "crawlSenyuubi_headerButton" : "hiddenItem"} style={styles.bookedConfirm} tabIndex={props.tabIndex}>
            <Link linkTitle="占有日照会" style={styles.linkLabel} onClick={() => onClickSenyuubi()} />
          </div>
          {isWidePhone ? null :
            <div className={props.bookedConfirmLabel ? "membership_headerBaseRight" : "hiddenItem"} tabIndex={props.tabIndex}>
              <Link linkTitle={props.bookedConfirmLabel} style={styles.linkLabel} onClick={() => onClickOpenReservationPopupWindow(pointKaiinId)} />
            </div>
          }
        </div>
        <div className={isWidePhone && props.bookedConfirmLabel ? "membership_headerBaseRight" : "hiddenItem"} tabIndex={props.tabIndex}>
          <Link linkTitle={props.bookedConfirmLabel} style={styles.linkLabel} onClick={() => onClickOpenReservationPopupWindow(pointKaiinId)} />
        </div>
      </div>}
      <div className="membership_headerBaseWrapper2" >
        <div className={isWideTablet ? "membership_headerCenterWrapperSp" : "membership_headerCenterWrapper"}>
          <div className="membership_headerLabelWrapper">
            <div>
              {isWideTablet && props.path ?
                <div style={{ position: "absolute", left: 40, top: "29%", justifyContent: "center" }} onClick={onClickBack}>＜</div>
                : null}
              {/* HACK 小手先対応 お客様情報入力（人数・レストラン変更）でスマホの時のみ改行したい*/}
              {LINEFEED_LABEL === props.categoryLabel1 ?
                <>
                  {isWideTablet ?
                    <>
                      <Label label={'お客様情報入力'} className={"membership_LabelStyleSp1"} />
                      <Label label={'（人数・レストラン変更）'} className={"membership_LabelStyleSp1_2"} />
                    </>
                    :
                    <Label label={props.categoryLabel1} className={"membership_LabelStyle1"} />
                  }
                </>
                :
                <Label label={props.categoryLabel1} className={isWideTablet ? "membership_LabelStyleSp1" : "membership_LabelStyle1"} />
              }
              <Label label={props.categoryLabel2} className={isWideTablet ? "membership_LabelStyleSp2" : "membership_LabelStyle2"} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const styles = {


  spLabelStyle1: {
    width: "100%",
    fontSize: "1rem",
    margin: "0 auto",
    marginTop: "20px",
    color: "black",
    textAlign: "center",
    letterSpacing: "0.2rem",
    marginTop: "1rem",
    fontWeight: "700",
  },

  spLabelStyle2: {
    width: "100%",
    fontSize: "0.5rem",
    textAlign: "center",
    marginBottom: "1rem",
    color: "#707070",
  },


  pcLabelStyle1: {
    width: "100%",
    fontSize: "1.5rem",
    margin: "0 auto",
    //marginTop: "20px",
    color: "black",
    textAlign: "center",
    letterSpacing: "0.2rem",
    marginTop: "1.5rem",
    fontWeight: "bold",
  },

  pcLabelStyle2: {
    width: "100%",
    fontSize: "0.8rem",
    textAlign: "center",
    marginBottom: "1.5rem",
    color: "#707070",
  },

  headerBaseRightLogout: {
    float: "right",
    marginTop: "0.7rem",
    marginRight: "0.7rem",
    letterSpacing: "0.05rem",
    fontWeight: 500,
  },

  headerLogout: {
    textDecoration: 'none',
    fontSize: "12px",
    textAlign: "center",
    color: "black"
  },
};
